import { Component, Inject, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CmfInterface } from '../../../interface/cmf-interface';
import { CmfServiceService } from '../../../service/cmf-service.service';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { Permissions } from 'src/app/common/permissions';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-detalle-cmf',
  templateUrl: './detalle-cmf.component.html',
  styleUrls: ['./detalle-cmf.component.scss'],
})
export class DetalleCmfComponent {
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @Input() formularioCMF: string = "";
  public mostrarCerrar: boolean = true;
  public dataSource: MatTableDataSource<CmfInterface>;
  public listaCmf: Array<CmfInterface> = new Array();
  public requestDate: Date|undefined = undefined;
  public headers: string[]
  public hasUpdatePermission:boolean = false;

  public inputColumns = [
    'dirvigente',
    'dirmorosa',
    'dirvencida',
    'dirconsumo',
    'diracreedor',
    'dirhipotecaria',
    'dirinversion',
    'diroperacionpacto',
    'dircomercial',
    'credcontingente',
    'monexvigente',
    'monexvencida',
    'indirectavig',
    'indirectaven',
    'castigadadirecta',
    'castigadaindirecta',
    'leasingvig',
    'leasingmor',
    'lineacredito',
    'dirven180mayor3year'
  ];

  public DebtTypeDict = {
    castigadadirecta: 'Castigada Dir.',
    castigadaindirecta: 'Castigada Ind.',
    credcontingente: 'Contingente',
    diracreedor: 'Dir. Acreedor',
    dircomercial: 'Dir. Comercial',
    dirconsumo: 'Dir. Consumo',
    dirhipotecaria: 'Dir. Hipotecaria',
    dirinversion: 'Dir. Inversion',
    dirmorosa: 'Dir. Morosa',
    diroperacionpacto: 'Dir. Ope. Pacto',
    dirven180mayor3year: 'Dir. Venc. 180 > 3 Años',
    dirvencida: 'Dir. Vencida',
    dirvigente: 'Dir. Vigente',
    indirectaven: 'Indirecta Vencida',
    indirectavig: 'Indirecta Vigente',
    leasingmor: 'Leasing Morosa',
    leasingvig: 'Leasing Vigente',
    lineacredito: 'Linea de Credito',
    monexvencida: 'Monex Vencida',
    monexvigente: 'Monex Vigente'
  }

  public displayedColumns: string[];
  public displayData: any[];
  public showTable: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public dialogRef: MatDialogRef<DetalleCmfComponent>,
    private cmfService: CmfServiceService,
    private authService: AuthService
  ) {
    this.convertirRut(this.data['rut']);
    this.hasUpdatePermission = authService.ValidateUserPermission(Permissions.GetNewSbifDebt)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formularioCMF'].currentValue == 'true') {
      this.mostrarCerrar = false;
    }
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

  convertirRut(rut: any) {
    if (typeof rut === 'string') {
      var miIdCompany;
      const cleanedRutWithoutDots = rut.replace(/\./g, '');
      miIdCompany = parseInt(
        cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
      );
      this.consltarCMF(miIdCompany);
    }

    if (typeof rut === 'number') {
      this.consltarCMF(rut);
    }
  }

  consltarCMF(companyId: number) {
    
    this.listaCmf = new Array();
    this.requestDate = new Date();
    this.cmfService.getCmf(companyId).subscribe({
      next: (next) => {
        this.listaCmf = next.cmfDebts;
        this.requestDate = next.requestDate;
        this.setDataSource(this.listaCmf);
      },
    });
  }

  private setDataSource(dataSource: Array<CmfInterface>) {
    this.dataSource = new MatTableDataSource<CmfInterface>(dataSource);
    let displayColumnsNumber = dataSource.map((x,i) => i);
    this.displayedColumns = displayColumnsNumber.map((x) => x.toString());
    const maxPosition = Math.max(...displayColumnsNumber)+1;

    this.displayedColumns.push(maxPosition.toString())
    this.headers = dataSource.map((x) => x.year.toString()+"-"+x.month.toString());
    this.headers.unshift(" ");
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.displayData = this.inputColumns.map(x => this.formatInputRow(x));
  }

  formatInputRow(row) {
    const output = {};
    output[0] = row;
    for (let i = 1; i < this.dataSource.data.length+1; ++i) {
      output[i] = this.dataSource.data[i-1][row];
    }
    console.log("output");
    console.log(output);
    return output;
  }

  updateSbif(){
    Swal.fire({
      heightAuto: false,
      title: 'Actualizando',
      text: 'Actualizando información',
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let rutToUpdate = this.data['rut'].toString().replaceAll(".","").split("-")[0];
    this.cmfService.updateSbif(rutToUpdate).subscribe({
      next: (next) => {
        this.consltarCMF(parseInt(rutToUpdate));
        Swal.fire({
          heightAuto: false,
          title: 'Listo',
          text: 'Se ha actualizado la deuda sbif',
          icon: 'success',
        }).then((result) => {
        });
      },
      error: (err) => {
        Swal.fire({
          heightAuto: false,
          icon: 'error',
          text: err.error.resultMessage
        });
      }
    });
  }
}
